import { Wheat } from "lucide-react";

export default function ImageSlot({ src, alt = "", position = "center", className = "", children }) {
  return (
    <div className={`relative w-full overflow-hidden ${src ? "" : "grain"} ${className}`} style={{ background: "var(--em-stone-hover)" }}>
      {src ? (
        <img src={src} alt={alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: position }} />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center" style={{ color: "var(--em-border)" }}>
          <Wheat size={56} strokeWidth={1} />
        </div>
      )}
      {children}
    </div>
  );
}
